import { Injectable } from '@angular/core';
import { Product } from '@core/models/piramide/Product';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HighlightedProductsService {
  public altHighlighted: BehaviorSubject<string> = new BehaviorSubject<string>('Logi Play Days');
  private isDateHighlighted: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private strictProductIds: Array<number> = [
    12787, 10914, 13882, 13879, 13881, 15642, 15637, 14468, 15638, 15949, 15950, 15632, 14460,
    15644, 12389, 13802, 12390, 9156, 10216, 11085, 11086, 11197, 11200, 15665, 15689, 14461, 13696,
    12772, 15654, 15655, 13610, 14876, 11695, 10729, 9558, 9548, 14355, 14642, 14356, 15650, 9734,
    15945, 14641, 15643, 15645, 10416, 9365, 15690, 11595, 10157, 13745, 15633, 15634, 15662, 15663,
    15664, 11027, 10078, 10255,
  ];

  constructor() {
    const today = new Date();

    // (año | mes | dia) el mes tiene que ser igual al mes de la promo -1
    const startDateHighlighted = new Date(2024, 7, 1);
    const endtDateHighlighted = new Date(2024, 8, 1);
    //Comprueba si se tiene que mostrar el boton y descuentos, solo si esta en el rango propuesto
    if (endtDateHighlighted > today && startDateHighlighted < today) {
      this.isDateHighlighted.next(true);
    } else {
      this.isDateHighlighted.next(false);
    }
  }

  public isProductHighlighted(idProduct: number): boolean {
    return this.strictProductIds.find((p) => p == idProduct) && this.isDateHighlighted.getValue();
  }

  public isDateHighligthed(): boolean {
    return this.isDateHighlighted.getValue();
  }
}
